import fecha from 'fecha'

export default date => {
  if (date.length > 0) {
    return `${fecha.format(new Date(date), 'DD.MM.YY, HH:mm')} Uhr`
  }
}



// WEBPACK FOOTER //
// ./src/filters/fullDateTime.js